
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/the-latest/page/[pageNum]",
      function () {
        return require("private-next-pages/the-latest/page/[pageNum].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/the-latest/page/[pageNum]"])
      });
    }
  